"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Flyout.scss");
var _externalArrowWhiteTheme = _interopRequireDefault(require("../../images/external-arrow-white-theme.svg"));
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _utilizeFocus = require("../../utils/utilizeFocus");
var _searchHighlighted = _interopRequireDefault(require("../../images/search-highlighted.svg"));
var _checkForExternalLink = _interopRequireDefault(require("../../utils/checkForExternalLink"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Image = _interopRequireDefault(require("../Image/Image"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const formatInitials = name => {
  let initials = 'N/A';
  if (typeof name == 'string' && name.length > 0) {
    const nameComponents = name.split(' ');
    nameComponents.slice(0, 3).forEach((nameComponent, index) => {
      if (index === 0) {
        initials = '';
      }
      initials += nameComponent.charAt(0);
    });
  }
  return initials;
};
const Flyout = props => {
  const {
    logo,
    Link,
    searchPlaceholder,
    disableSearch,
    close,
    searchSubmit,
    searchDeployed,
    setSearchDeployed,
    setDesktopSearchDeployed,
    desktopSearchDeployed,
    languageSelectorDeployed,
    handleLanguageSelectorDeployed,
    closeHamburger,
    globalSearch,
    setGlobalSearch,
    login,
    authenticated,
    profile,
    signInLabel,
    signOutLabel,
    backbtnLabel,
    createAccount,
    marketingLinks,
    ecommerceLinks,
    customLinks,
    myAccountLinks,
    legalLinks,
    signInBtnMethod = () => {},
    signOutBtnMethod = () => {},
    sectorFlyoutDeployed,
    accountSwitcher
  } = props;
  const [searchField, setSearchField] = (0, _react.useState)("");
  const {
    mouse
  } = (0, _useMouse.default)();
  const inputFocus = (0, _utilizeFocus.utilizeFocus)();
  const handleClickClose = () => {
    close();
  };
  const handleSearchFieldChange = e => {
    setSearchField(e.target.value);
  };
  const handleSearchSubmit = () => {
    searchSubmit(searchField);
  };
  const openSearchComponent = () => {
    setDesktopSearchDeployed(true);
    close();
    closeHamburger();
    setGlobalSearch(true);
  };
  const generateTID = () => {
    if (!authenticated) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "ter-flyout__logo-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
        tabIndex: mouse ? "" : "0",
        "aria-label": `link to homepage`,
        to: logo?.link?.url,
        style: {
          textDecoration: "none"
        },
        className: "flyout-links__link",
        Link: Link
      }, /*#__PURE__*/_react.default.createElement(_Image.default, {
        image: logo?.image || null,
        src: logo?.url || logo?.src,
        alt: logo?.altText || logo?.alt,
        GatsbyImage: logo?.GatsbyImage,
        className: "ter-flyout__logo"
      }))), login && /*#__PURE__*/_react.default.createElement("div", {
        className: "ter-flyout__buttons-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: "ter-button--secondary--1",
        size: "sm",
        onClick: () => {
          signInBtnMethod();
        }
      }, signInLabel || "Sign In"), createAccount?.url && /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
        to: createAccount?.url,
        className: "ter-button ter-button--secondary--2 ter-button--small",
        size: "sm",
        tabIndex: mouse ? "" : "0",
        "aria-label": `Link to ${createAccount?.text || 'Create account'}`,
        Link: Link
      }, createAccount?.text || "Create account")));
    } else {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "ter-flyout__section ter-flyout__section--profile"
      }, /*#__PURE__*/_react.default.createElement(ProfileImage, {
        profile: profile
      }), /*#__PURE__*/_react.default.createElement(ProfileDetails, {
        profile: profile
      }));
    }
  };
  const ProfileImage = _ref => {
    let {
      profile
    } = _ref;
    if (!profile) {
      return null;
    }
    if (profile?.image) {
      return /*#__PURE__*/_react.default.createElement("img", {
        className: "ter-flyout__section--profile__image",
        src: profile?.image?.src,
        alt: profile?.image?.alt
      });
    } else {
      const initials = formatInitials(profile?.name);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "ter-flyout__section--profile__no-image"
      }, initials);
    }
  };
  const ProfileDetails = _ref2 => {
    let {
      profile
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-flyout__section--profile__text-area"
    }, /*#__PURE__*/_react.default.createElement("h6", {
      className: "ter-flyout__section--profile__name"
    }, profile?.name), profile?.role && /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-flyout__section--profile__role"
    }, profile?.role), profile?.organization && /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-flyout__section--profile__organization"
    }, profile?.organization));
  };
  const generateFlyoutLinks = links => {
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: "flyout-links__menu"
    }, links && links.filter(link => link?.url).map((link, index) => {
      const isExternal = (0, _checkForExternalLink.default)(link?.url);
      const handleClick = () => {
        if (!isExternal) {
          close();
        }
      };
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "flyout-links__item",
        key: index
      }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
        tabIndex: mouse ? "" : "0",
        key: `${link?.text}-${index}`,
        "aria-label": `Link to ${link?.text}`,
        to: link?.url,
        className: "flyout-links__link",
        onClick: handleClick,
        Link: Link,
        rel: link?.external ? "noopener" : ""
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "flyout-links__link-text"
      }, link?.text), isExternal && /*#__PURE__*/_react.default.createElement("figure", {
        role: "none",
        className: "flyout-links__link-icon"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _externalArrowWhiteTheme.default,
        alt: `link to ${link?.text}`,
        style: {
          height: "20px",
          width: "20px"
        }
      }))));
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: sectorFlyoutDeployed ? "ter-flyout__modal ter-flyout__modal--deployed" : "ter-flyout__modal",
    onClick: handleClickClose
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-flyout ${sectorFlyoutDeployed ? 'ter-flyout--deployed' : ''}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-flyout__panel ter-flyout__panel--2${accountSwitcher?.isOpen ? " ter-flyout__panel--2--deployed" : ""}`
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "ter-flyout__panel--2__close-btn",
    onClick: () => accountSwitcher?.setOpen(false)
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "8",
    height: "12",
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.70508 10.595L3.12508 6.005L7.70508 1.415L6.29508 0.00500482L0.295079 6.005L6.29508 12.005L7.70508 10.595Z",
    fill: "#252A2E"
  })), backbtnLabel || 'Back'), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-flyout__panel--2__body"
  }, accountSwitcher?.accounts?.map((account, index) => {
    const isActive = account?.id === accountSwitcher?.accountId;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: `ter-flyout__account${isActive ? " ter-flyout__account--active" : ''}`,
      onClick: () => accountSwitcher?.onChange(account?.id)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-flyout__account__no-image"
    }, formatInitials(account?.name)), /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-flyout__account__column"
    }, account?.name && /*#__PURE__*/_react.default.createElement("h6", {
      className: "ter-flyout__account__name"
    }, account?.name), account?.role && /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-flyout__account__role"
    }, account?.role)), isActive && /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-flyout__account__check"
    }, /*#__PURE__*/_react.default.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z",
      fill: "#0063A3"
    }))));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-flyout__panel"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: authenticated ? "ter-flyout__close-btn--small ter-flyout__close-btn--small--authenticated" : "ter-flyout__close-btn--small",
    "aria-label": "closes-flyout-section",
    tabIndex: mouse ? "" : "0",
    onClick: handleClickClose
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.7 16.59L11.12 12L15.7 7.41L14.29 6L8.28995 12L14.29 18L15.7 16.59Z",
    fill: "currentColor"
  })), backbtnLabel || "Back"), /*#__PURE__*/_react.default.createElement("button", {
    className: "ter-flyout__close-btn",
    "aria-label": "closes-flyout-section",
    tabIndex: mouse ? "" : "0",
    onClick: handleClickClose
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.3 0.710011C12.91 0.320011 12.28 0.320011 11.89 0.710011L7 5.60001L2.11 0.710011C1.72 0.320011 1.09 0.320011 0.700001 0.710011C0.310001 1.10001 0.310001 1.73001 0.700001 2.12001L5.59 7.01001L0.700001 11.9C0.310001 12.29 0.310001 12.92 0.700001 13.31C1.09 13.7 1.72 13.7 2.11 13.31L7 8.42001L11.89 13.31C12.28 13.7 12.91 13.7 13.3 13.31C13.69 12.92 13.69 12.29 13.3 11.9L8.41 7.01001L13.3 2.12001C13.69 1.73001 13.69 1.10001 13.3 0.710011Z",
    fill: "white"
  }))), generateTID(), login && authenticated && myAccountLinks?.links && myAccountLinks?.links?.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-flyout__section ter-flyout__section--account"
  }, !accountSwitcher?.enabled && typeof myAccountLinks?.title === 'string' && /*#__PURE__*/_react.default.createElement("h6", {
    className: "ter-flyout__section__heading"
  }, myAccountLinks?.title), accountSwitcher?.enabled && /*#__PURE__*/_react.default.createElement("h6", {
    className: "ter-flyout__section__heading ter-flyout__section__heading--link",
    onClick: () => accountSwitcher?.setOpen(true)
  }, accountSwitcher?.title || "Switch Accounts", /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.29492 16.595L12.8749 12.005L8.29492 7.415L9.70492 6.005L15.7049 12.005L9.70492 18.005L8.29492 16.595Z",
    fill: "white"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-flyout__links"
  }, generateFlyoutLinks(myAccountLinks?.links), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-flyout__sign-out-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "ter-button--secondary--2 ter-flyout__sign-out-wrapper__btn",
    size: "sm",
    onClick: () => {
      signOutBtnMethod();
    }
  }, signOutLabel || "Sign Out")))), ecommerceLinks?.enabled !== false && authenticated && ecommerceLinks?.links && ecommerceLinks?.links?.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-flyout__section"
  }, typeof ecommerceLinks?.title == 'string' && /*#__PURE__*/_react.default.createElement("h6", {
    className: "ter-flyout__section__heading"
  }, ecommerceLinks?.title), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-flyout__links"
  }, generateFlyoutLinks(ecommerceLinks?.links))), customLinks?.enabled !== false && customLinks?.links && customLinks?.links?.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-flyout__section"
  }, typeof customLinks?.title === 'string' && /*#__PURE__*/_react.default.createElement("h6", {
    className: "ter-flyout__section__heading"
  }, customLinks?.title), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-flyout__links"
  }, generateFlyoutLinks(customLinks?.links))), marketingLinks?.enabled !== false && marketingLinks?.links && marketingLinks?.links?.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-flyout__section"
  }, typeof marketingLinks?.title === 'string' && /*#__PURE__*/_react.default.createElement("h6", {
    className: "ter-flyout__section__heading"
  }, marketingLinks?.title), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-flyout__links"
  }, marketingLinks?.links && generateFlyoutLinks(marketingLinks?.links)), !disableSearch && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-flyout__search"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-flyout__search-icon",
    onClick: () => openSearchComponent(),
    tabIndex: mouse ? "" : "0"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-flyout__search-text"
  }, searchPlaceholder), /*#__PURE__*/_react.default.createElement("img", {
    src: _searchHighlighted.default,
    alt: "Search"
  })))), legalLinks?.enabled !== false && legalLinks?.links && legalLinks?.links?.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-flyout__footer"
  }, legalLinks?.links?.map((d, i) => {
    return /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      key: i,
      to: d.url,
      tabIndex: mouse ? "" : "0",
      className: "ter-flyout__footer__link",
      "aria-label": d.text,
      Link: Link
    }, d.text);
  })))));
};
var _default = Flyout;
exports.default = _default;